import { render } from "./CallBack.vue?vue&type=template&id=63d276e6&scoped=true"
import script from "./CallBack.vue?vue&type=script&lang=js"
export * from "./CallBack.vue?vue&type=script&lang=js"

import "./CallBack.vue?vue&type=style&index=0&id=63d276e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d276e6"]])

export default __exports__